import React, { useContext, useState, useEffect } from 'react';

import proyectoContext from '../../context/proyectos/proyectoContext';
import xtareaContext from '../../context/extratareas/xtareaContext';


const FormTarea = () => {

    // extraer si un proyecto esta activo
    const proyectosContext = useContext(proyectoContext);
    const { proyecto } = proyectosContext;

    // obtener la funcion del context de xtarea
    const xtareasContext = useContext(xtareaContext);
    const {xtareaseleccionada, errorxtarea, agregarXtarea, validarXtarea, actualizarXtarea, limpiarXtarea} = xtareasContext;

    // effect que detecta si hay una tarea seleccionada
    useEffect(() => {
        if(xtareaseleccionada !== null) {
            setXtarea(xtareaseleccionada)
        } else{
            setXtarea({
                nombre: ''
            })
        }
        
    }, [xtareaseleccionada]);

    // state del formulario
    const [xtarea, setXtarea] = useState({
        nombre: ''
    });

    // extraer el nombre de la tarea del proyecto
    const { nombre } = xtarea;

    // si no hay proy seleccionado
    if(!proyecto) return null;

    // Array destructuring para extraer el proy actual
    const [proyectoActual] = proyecto;

    // leer los valores del formulario
    const handleChange = e => {
        setXtarea({
            ...xtarea,
            [e.target.name] : e.target.value
        })
    }

    const onSubmit = e => {
        e.preventDefault();

        // validar
        if(nombre.trim() === ''){
            validarXtarea();
            return;
        }

        // determina si es edicion o es nueva tarea
        if (xtareaseleccionada === null) {
            // es una nueva tarea => agregarla al state de tareas
            xtarea.proyecto = proyectoActual._id;
            //xtarea.estado = false; en el modelo ya esta definido como false
            agregarXtarea(xtarea);

        } else {
            // actualizar tarea existente
            actualizarXtarea(xtarea)
            //console.log(xtarea);
            // elimina xtarea seleccionada del state
            limpiarXtarea(); 
        }

        // obtener y filtrar las tareas del proyecto actual
        //obtenerXtareas(proyectoActual._id) //se retira porque solo funciona para datos estatios en el dev

        // reiniciar el form
        setXtarea({
            nombre: '' 
        })
    }

    return (  
        <div className="formulario">
            <form
                onSubmit={onSubmit}
            >
                <div className="contenedor-input">
                    <input 
                        type="text"
                        className="input-text"
                        placeholder="Nombre Tarea..."
                        name="nombre"
                        value={nombre}
                        onChange={handleChange}
                    />
                </div>
                <div className="contenedor-input">
                    <input 
                        type="submit"
                        className="btn btn-primary btn-submit btn-block"
                        value={xtareaseleccionada ? 'Guardar modificaciones' : 'Agregar Tarea'}
                    />
                </div>
            </form>
            {errorxtarea ? <p className="mensaje error">El nombre de la tarea es obligatorio</p> : null}
        </div>
    );
}
 
export default FormTarea;